
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
import { convertH2M, convertM2H } from '~/plugins/date'
import { REZERVATION_REQUEST } from '~/plugins/rezzervation'
import InnerLoading from '../Shared/Loading/InnerLoading.vue'
export default {
  components: { InnerLoading },

  data() {
    return {
      calendarKey: 1,
      refCalendar: {},
      timeCardKey: 0,
      calendarLoading: false,
      rezDate: { val: '' },
      attrs: [],
      disabledDays: [],
      time: '',
      times: [40, 80, 120, 240, 600, 870],
      days: [],
      localTime: '',
    }
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
    }),
    activeTimes() {
      const day = this.days.find((d) => d.id === this.rezDate.val) || {
        times: [],
      }
      return day.times.filter((time) => !time.isDisabled)
    },
  },
  props: {
    date: {
      default: () => ({ val: '', text: '' }),
    },
    propsTime: {
      default: '',
    },
    item: {
      default: () => {},
    },
  },
  methods: {
    Currency,
    convertH2M,
    convertM2H(n, gmt = false) {
      return convertM2H(n, this.getUserIP.offset, true, gmt)
    },
    SET_LOCALE_TIME(day = false) {
      let result = ''
      const realtTime = new Date().setHours(new Date().getUTCHours() + 3)
      if (!day) {
        result =
          new Date(realtTime).getHours() + ':' + new Date().getUTCMinutes()
      } else {
        result = new Date(realtTime).toLocaleString(this.$i18n.locale)
      }
      return result
    },
    SET_AFTER_DAY(day) {
      var date = new Date()
      date.setDate(date.getDate() + day)
      return date
    },
    SET_SMALL_REZ_DATE(day) {
      return new Date(day).toLocaleDateString(this.$i18n.locale, {
        month: 'short',
        day: '2-digit',
        year: '2-digit',
      })
    },
    SET_DATE(day) {
      this.$emit('change:time', '')
      this.time = ''
      this.rezDate = { val: '', text: '' }
      this.timeCardKey = this.timeCardKey + 1
      this.calendarKey += 1
      if (day.isDisabled) return
      this.rezDate = { val: day.id, text: day.ariaLabel }
    },
    UPDATE_FROM_PAGE() {
      this.attrs = []
      this.calendarLoading = true
      setTimeout(() => {
        this.$nextTick(() => {
          let self = this
          self.SET_CALENDAR(self.$refs.calendar)
        })
      }, 500)
    },
    GO_PAY_PAGE() {
      this.$emit('change:date', this.rezDate)
      this.$emit('change:time', this.time)
      this.$emit('update:step', 2)
    },
    SET_CALENDAR(calendar) {
      const days = calendar.firstPage.days || []
      if (days.length === 0) return
      let hgh = false
      //const hightLightIndex = this.attrs.find((a) => a.key === 'today')
      //if (hightLightIndex) hgh = hightLightIndex || {}
      // if (hgh) this.attrs = [hgh]
      this.attrs = []
      const firstDay = days[0].id
      const lastDay = days[days.length - 1].id
      this.GET_REZERVATIONS(firstDay, lastDay, days)
    },
    async GET_REZERVATIONS(firstDay, lastDay, days) {
      let rezList = []
      const department = this.item.department
      const startAt = convertH2M(department.OpenedAt) // açılış saati
      const closeAt = convertH2M(department.ClosedAt) // kapanış saati
      const breakStartAt = convertH2M(department.OffHoursStart) // mola başlangıç
      const breakCloseAt = convertH2M(department.OffHoursEnd) // mola bitiş
      const duration = department.Interval || 30 // aralık
      let time = startAt // while için başlangıç saati
      const response = await REZERVATION_REQUEST(
        `Rezervations/ForCustomerExternal?roomId=${this.item.department.Id}&startDate=${firstDay}&endDate=${lastDay}`,
        'get',
        {},
        {
          Authorization: `Bearer ${this.item.Token}`,
          'Content-Type': 'application/json',
        }
      )
      if (response.message === 'OK') rezList = response.data || []
      const todayTime = this.SET_LOCALE_TIME()
      const timeWithMunites = this.convertH2M(todayTime)
      this.localTime = todayTime
      this.days = days.map((day) => {
        time = startAt
        const rezsOnDay = rezList.filter((rez) =>
          rez.RezervationDate.includes(day.id)
        )
        const times = []
        if (day.isDisabled)
          return {
            ...days,
            times: [],
          }
        const disabledDays = []
        const activeDays = []
        while (time < closeAt) {
          const rez = rezsOnDay.find((rez) => rez.RezervationTime === time)
          if (day.isToday) {
            if (timeWithMunites < time) {
              activeDays.push(day.id)
              times.push({
                timeString: this.convertM2H(time, true),
                time,
                isDisabled: false,
                isHurry: time - timeWithMunites < 11,
              })
            } else {
              disabledDays.push(day.id)
              times.push({
                timeString: this.convertM2H(time, true),
                time,
                isDisabled: true,
              })
            }
            time = time + duration
          } else if (breakStartAt <= time && time < breakCloseAt) {
            time = breakCloseAt
          } else if (rez) {
            const x = Math.ceil(rez.Duration / duration)
            disabledDays.push(day.id)
            times.push({
              timeString: this.convertM2H(time, true),
              time,
              isDisabled: true,
              endDate: time + rez.Duration,
            })
            time = time + duration * x
          } else {
            activeDays.push(day.id)
            times.push({
              timeString: this.convertM2H(time, true),
              time,
              isDisabled: false,
            })
            time = time + duration
          }
        }
        const flexGrow = Math.ceil(
          (activeDays.length * 100) /
            (activeDays.length + disabledDays.length) /
            10
        )
        this.attrs.push({
          bar: {
            style: {
              backgroundColor:
                flexGrow > 8
                  ? '#85da9a'
                  : flexGrow > 6
                  ? '#C7F2A4'
                  : flexGrow > 4
                  ? '#FFB26B'
                  : flexGrow > 1
                  ? '#850000'
                  : '#EEEEEE',
              flexGrow,
            },
          },
          dates: activeDays,
          popover: {
            label: `${this.$custom$t('thereIsAppoinments', {
              length: activeDays.length,
            })}`,
            hideIndicator: true,
          },
        })
        this.attrs.push({
          bar: {
            style: {
              backgroundColor: '#EEEEEE',
              flexGrow: Math.ceil(
                (disabledDays.length * 100) /
                  (activeDays.length + disabledDays.length) /
                  10
              ),
            },
          },
          dates: disabledDays,
        })
        if (activeDays.length === 0) this.disabledDays.push(new Date(day.id))
        return {
          ...day,
          times,
        }
      })
      this.calendarLoading = false
    },
  },
  mounted() {
    this.attrs.push({
      key: 'today',
      highlight: {
        style: {
          backgroundColor: '#34ab52',
        },
      },
      dates: new Date('1977-01-01'),
    })
    this.rezDate = this.date
    this.time = this.propsTime
    this.$nextTick(() => {
      let self = this
      setTimeout(async () => {
        if (self.date.val !== '') {
          self.attrs.push({
            key: 'today',
            highlight: true,
            dates: new Date(self.date.val),
          })
          await self.$refs.calendar.move(self.date.val)
        }
      }, 200)
    })
  },
}
